// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__pxmn6","label":"styles_label__128E4"};